import type { FaireProductEntity } from "../../entity_types/product";

export const p_emm3sbjp43: FaireProductEntity = {
  token: "p_emm3sbjp43",
  type: "product",
  name: "Candy-Colored Casual Street Style Blazer",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/82159ff41b929b775b668667403fa12f3f57e49ea51f60066c3ca9ef8eedb4c0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba00c29812de06f84fd2f185a888161144ec4a53e7f5fca0bacd066de495c910.jpeg",
    "https://cdn.faire.com/fastly/bc304af2a4e38d6acc2d1a959df90516f458f45e00271683ab7238038097c990.jpeg",
    "https://cdn.faire.com/fastly/7bc6c9cfb51d16e02a9e26fc32cf1fa42b47a7757db4e6e6005d431794e141b9.jpeg",
    "https://cdn.faire.com/fastly/f90374683b3917dc7ea7a7f1a9ee43a9af6c422cf971d1bb8bf42012026858cc.jpeg",
    "https://cdn.faire.com/fastly/bc6ea9f241309551d9da4ae05faabc05c4aa053bad0b03f9652725e7dd2c10ef.jpeg",
    "https://cdn.faire.com/fastly/e788eb9044e2d4fcb119cb2ed9d7bb38fd93e0be73629945846e2a027b6339e2.jpeg",
    "https://cdn.faire.com/fastly/a4e1c0a8c5a6da1651d6382cf4f1633227fa969664a7ce002284076d55c4ed59.jpeg",
    "https://cdn.faire.com/fastly/fcf202cd2cfb941a25543e95041ae6d3b238e009aace0a1bf9bbe09ca69026b2.jpeg",
  ],
  priceDollars: 19.99,
  description:
    "Material:Dacron\n\nStyle:Loose,Intellectual,All-match,Look-younger\n\nFeature:Plain\n\nNeckline:Tailored\n\nOccasion:Going out,Casual,Office,Artistic Retro,Girlish Sweetness,Light Maturity,Stylish Selection,Leisure Fashion\n\nSeasons:Spring,Autumn\n\nType:Suit Jacket\n\nSleeve Length:Long Sleeve\n\nSleeve Style:Raglan Sleeve\n\nSize S (inch) : Bust= 35.10 ; Shoulder= 14.43 ; Sleeve= 21.84 ; Length= 26.13 ; \n\nSize M (inch) : Bust= 36.66 ; Shoulder= 14.82 ; Sleeve= 22.23 ; Length= 26.52 ; \n\nSize L (inch) : Bust= 38.22 ; Shoulder= 15.21 ; Sleeve= 22.62 ; Length= 26.91 ; \n\nSize XL (inch) : Bust= 39.78 ; Shoulder= 15.60 ; Sleeve= 23.01 ; Length= 27.30 ; \n\nSize 2XL (inch) : Bust= 41.34 ; Shoulder= 15.99 ; Sleeve= 23.40 ; Length= 27.69 ; \n\nSize 3XL (inch) : Bust= 42.90 ; Shoulder= 16.38 ; Sleeve= 23.79 ; Length= 28.08 ;",
  tags: [],
  msrpDollars: 39.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:16.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
